<template>
  <div class="intvTimeCale" :style="cssVar">
    <div class="cale_tip">
      <div class="no_select">
        <span class="icon_tip kdfont kdfont-zhuangtai_jingshi" v-if="pageState==='edit'"></span>
        <span v-if="pageState==='edit'">{{getLangMsg("setIntvTime_key001")}}</span></div>
      <div class="color_desc">
        <div class="can_intv"><span class="can_colorBlock"></span><span>{{getLangMsg("setIntvTime_key002")}}</span></div>
        <div class="cannot_intv" v-if="pageState==='edit'"><span class="cannot_colorBlock"></span><span>{{getLangMsg("setIntvTime_key003")}}</span>
        </div>
      </div>
    </div>
    <div class="cale">
      <div class="cale_changeDate">
        <div style="width:200px">{{currentYYMM}}</div>
        <div class="tab_week">
          <span class="kdfont kdfont-fangxiangzuo pointer" :class="{'unable':!nextWeekNum}" @click="toLastWeek"></span>
          <span class="date_text">{{ currentWeek }}</span>
          <span class="kdfont kdfont-fangxiangyou pointer" @click="toNextWeek"></span>
          <span class="date_today" @click="returnToday">{{getLangMsg("setIntvTime_today")}}</span>
        </div>
        <div style="width:200px"></div>
      </div>
      <div class="cale_body">
        <div class="date_title">
          <div class="blank_space">{{getLangMsg("setIntvTime_key004")}}</div>
          <div class="date_title_items">
            <div class="title_item" :class="{'hideInputBox':!(pageState==='edit')}"
                 v-for="(item,index) in weekDateNameList">
              <el-checkbox v-model="allSelectedArr[index]"
                           :disabled="new Date(getZeroTime(weekDateList[index])) <= new Date(getZeroTime())"
                           @change="checked=>changeAllSelected(checked,weekDateList[index])">
                {{ weekDateList[index] | clearYear }} {{ item }}
              </el-checkbox>
              <div class="isToday" v-if="judgeIsToday(weekDateList[index])">
                {{getLangMsg("setIntvTime_today")}}
              </div>

            </div>
          </div>
        </div>
        <div class="date_body">
          <div class="scroll_content">
            <div class="date_body_scale">
              <div class="scale_item" v-for="(item,index) in 48" :style="{'lineHeight':formatScale(item)==='22:00'?'0px':'normal'}">
                {{ index % 2 === 1 ? '' : formatScale(item) }}
              </div>
            </div>
            <div class="date_body_content pointer" @mousedown.stop.prevent="mousedownBody"
                 @mouseup.stop="closeHoverState">
              <div class="day_list" v-for="(item,index) in weekDateList">
                <div class="hours_list" draggable="false" data_type="default" v-for="(itemHours,indexH) in 48"
                     :class="{'ishover':judgeIsHover(formatCompleteTime(item,itemHours)),'isunable':judgeIsUnable(formatCompleteTime(item,itemHours)),'isable':judgeIsAble(formatCompleteTime(item,itemHours))}"
                     @mouseenter.stop.prevent="mouseenterNode($event,formatCompleteTime(item,itemHours))"
                     @mousedown="mousedownNode($event,formatCompleteTime(item,itemHours))"
                >
                  <!--                  <div class="min_list" v-if="judgeIsShowMin(formatCompleteTime(item,itemHours))">-->
                  <!--                    <div class="min_list_item" v-for="(itemMin,indexM) in 6"-->
                  <!--                         :class="{'isunable':judgeMinIsUnable(formatCompleteTime(item,itemHours),indexM)}"></div>-->
                  <!--                  </div>-->
                </div>
                <!--查看态视图-->
                <div class="viewTime_block" v-if="pageState==='view' && viewCanIntvTime[new Date(item).getTime()] !== undefined">
                  <div class="viewBlock_item" v-for="(itemBlock,indexB) in viewCanIntvTime[new Date(item).getTime()]"
                       :style="{top:calcTop(itemBlock),height:calcHeight(itemBlock)}" @mousedown.stop.prevent="">
                    {{ itemBlock.startTime | format_hhmm_start }} ~ {{ itemBlock.endTime | format_hhmm_end }}
                  </div>
                </div>
                <!--查看态视图-->
                <!--编辑态不可面试时间-->
                <div class="viewunableTime_block" v-if="pageState==='edit' && viewUnableIntvTime[new Date(item).getTime()] !== undefined">
                  <div class="viewunableBlock_item" v-for="(itemBlock,indexB) in viewUnableIntvTime[new Date(item).getTime()]"
                       :style="{top:calcTop(itemBlock),height:calcHeight(itemBlock)}" @mousedown.stop.prevent="">
                  </div>
                </div>
                <div class="viewunableTime_block" v-if="pageState==='edit'">
                  <div class="viewunableBlock_item" v-if="new Date(getZeroTime(item)) < new Date()"
                       :style="{top:0,height:caleHeightForToday(item)}"
                       @mousedown.stop.prevent="">
                  </div>
                </div>
                <!--编辑态不可面试时间-->
              </div>
              <div class="timeLine" v-show="judgeIsOfCurWeek()">
                <div class="dot"></div>
              </div>
              <div class="occupy" @mousedown.stop.prevent=""></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noTipOfWeek" v-if="customDataObj && customDataObj.isShowWeekTip">
      <el-checkbox v-model="noTipOfWeek">{{getLangMsg("setIntvTime_key005")}}</el-checkbox>
    </div>
  </div>
</template>

<script>
import {utils} from '../common/common'

export default {
  components: {},
  props: {
    customDataObj: Object,
    invoke: Function,
    customEvtName: String,
    themeNum:String,
    lang:String
  },
  computed: {
    currentYYMM(){
      if (!this.oneDayOfWeek) { return '';}
      return utils.dateFormat(this.getLangMsg("setIntvTime_key007"), this.oneDayOfWeek);
    },
    currentWeek() {
      if (!this.oneDayOfWeek) {return '';}
      let weekNum = utils.getWeekOfYear(this.getZeroTime(this.oneDayOfWeek))
      return this.getLangMsg("setIntvTime_key006",{'text':utils.numToChinese(weekNum)})
    },
    cssVar() {
      return {
        '--color': this.themeNum,
        '--color-thin': utils.colorContrast[this.themeNum]
      }
    },
  },
  watch: {
    oneDayOfWeek: function (val) {
      this.weekDateList = utils.getWeek(val);
      let week1 = this.getZeroTime(this.weekDateList[0]);
      let week7 = this.getZeroTime(this.weekDateList[6]);
      if (this.startSelectedDate > week1 || this.endSelectedDate < week7) {
        this.invoke('getIntvData', {"startTime": new Date(this.weekDateList[0]).getTime(), "endTime": new Date(this.weekDateList[6]).getTime()})
      }
      //记录用户查看过的日期
      if (this.startSelectedDate >= week1) {
        this.startSelectedDate = week1
      }
      if (this.endSelectedDate <= week7) {
        this.endSelectedDate = week7
      }
      this.judgeIsAllSelectedOneDay()
    },
    customDataObj: function (val) {
      this.pageState = val.pageState !== undefined ? val.pageState : 'view';
      let ableInterviewTime = val.ableInterviewTime;
      let unableInterviewTime = val.unableInterviewTime;
      if (this.pageState === 'view') {
        for (let index in ableInterviewTime) {
          this.viewCanIntvTime[ableInterviewTime[index].interviewDate] = ableInterviewTime[index].periodList;
        }
      } else {
        //绘制可面试时间结构数组(编辑态)
        this.formtCanintvTimeArr(ableInterviewTime);
        //绘制不可面试时间结构数组（编辑态）
        this.formtUnableIntvTimeArr(unableInterviewTime);
        for (let index in unableInterviewTime) {
          this.viewUnableIntvTime[unableInterviewTime[index].interviewDate] = unableInterviewTime[index].periodList;
        }
        this.judgeIsAllSelectedOneDay();
      }
      if(!this.isRegisterScroll){
        this.registerScroll();
        this.isRegisterScroll = !this.isRegisterScroll;
      }


    },
    customEvtName: function (val) {
      if (val === 'submit') {
        this.invoke('setIntvData', this.assemblyDataToForm())
      } else if (val.indexOf('cancel') > -1) {
        this.invoke('closePageAgo_isChange', this.judgeIsChangeOriginData())
        console.log('closePageAgo_isChange', this.judgeIsChangeOriginData())
      }
    }
  },
  filters: {
    clearYear(time) {
      if (time != undefined || time != null) {
        return String(time).substring(5);
      } else {
        return ''
      }
    },
    format_hhmm_start(time) {
      return utils.dateFormat('hh：mm', time)
    },
    format_hhmm_end(time) {
      return utils.dateFormat('hh：mm', time) === '00：00' ? '23：59' : utils.dateFormat('hh：mm', time)
    }

  },
  data() {
    return {
      weekDateNameList: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
      oneDayOfWeek: '',
      weekDateList: ["2020/03/09", "2020/03/10", "2020/03/11", "2020/03/12", "2020/03/13", "2020/03/14", "2020/03/15"],//周日期
      allSelectedArr: [false, false, false, false, false, false, false],
      ishoverState: false,//是否处于选择可面试时间状态
      isOperation: false,
      canIntvTime: [],//存放可面试时间集合
      canIntvTimeBackups: [],
      viewCanIntvTime: {},
      viewUnableIntvTime: {},
      unableTime: [],//存放不可用时间集合
      noIntPointTime: {'1629783000000': [1629783300000, 1629783600000]},
      startMoveTime: '',//选择时间时的开始时间点
      endMoveTime: '',//选择时间时的结束时间点
      noTipOfWeek: false,
      pageState: 'view',  //edit编辑  view查看
      startSelectedDate: null,
      endSelectedDate: null,
      pageConstant: {
        hoursBlockHeight: 30,
        hoursBlockMarginBtm: 2,
        dateBlockHeight: (30 + 2) * 48  //每天有48个格子，精度为30分钟
      },
      isLimit_8_22: true,
      nextWeekNum: 0,
      scrollTimer: null,
      scrollSpeed: 0,
      isRegisterScroll:false
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //赋值周一到周日的多语言文字
      this.weekDateNameList = [this.getLangMsg("setIntvTime_mon"),
        this.getLangMsg("setIntvTime_tues"),
        this.getLangMsg("setIntvTime_wednes"),
        this.getLangMsg("setIntvTime_thurs"),
        this.getLangMsg("setIntvTime_fri"),
        this.getLangMsg("setIntvTime_satur"),
        this.getLangMsg("setIntvTime_week")]
      //去除滚动条
      this.hideScrollBar();
      //注册滚动监听 限制只展示8-22点,这里先初始滚动到头部8点处
      if (this.isLimit_8_22) {
        let el = $(".intvTimeCale .scroll_content");
        let minScrollNum = 32 * 16;
        el.scrollTop(minScrollNum);
      }
      //初始化日期
      this.oneDayOfWeek = new Date().getTime();
      //初始化时间线
      this.initTimeLine();
      //初始化用户查看开始日期与结束日期
      this.startSelectedDate = new Date().getTime();
      this.endSelectedDate = new Date().getTime();
      //填充当天的过去时间做为不可面试时间
      this.setTodayPassTimeToUnableTime();
    },
    initTimeLine() {
      let this_ = this;
      let timePer = (new Date().getTime() - this.getZeroTime()) / (24 * 60 * 60 * 1000);
      let caleHeight = this.pageConstant.dateBlockHeight;
      $(".intvTimeCale .timeLine").css('top', caleHeight * timePer + 'px')
      let timeLineInterval = setInterval(function () {
        timePer = (new Date().getTime() - this_.getZeroTime()) / (24 * 60 * 60 * 1000);
        $(".intvTimeCale .timeLine").css('top', caleHeight * timePer + 'px')
      }, 60000)
    },
    setTodayPassTimeToUnableTime() {
      let todayPassTimeList = this.createTimeList(this.getZeroTime(), new Date().getTime())
      todayPassTimeList.length = todayPassTimeList.length - 1;
      for (let x in todayPassTimeList) {
        if (!this.unableTime.includes(todayPassTimeList[x])) {
          this.unableTime.push(todayPassTimeList[x]);
        }
      }
      console.log(todayPassTimeList)
    },
    toLastWeek() {
      if (this.nextWeekNum > 0) {
        this.oneDayOfWeek = utils.getNextDate(this.oneDayOfWeek, -7);
        this.nextWeekNum--;
      }
    },
    toNextWeek() {
      this.oneDayOfWeek = utils.getNextDate(this.oneDayOfWeek, 7);
      this.nextWeekNum++;
    },
    returnToday() {
      this.oneDayOfWeek = new Date().getTime();
      this.nextWeekNum = 0;
    },
    changeAllSelected(value, date) {
      if (this.pageState === 'view') {
        return;
      }
      let selectedTime = this.createTimeList(new Date(date + " 00:00").getTime(), new Date(date + " 23:30").getTime())

      //点击全选的时候不抛掉不可面试时间，所以注释掉下面这行代码
      // selectedTime = utils._removeArr(selectedTime, this.unableTime);

      if (value) {
        for (var i = 0, len = selectedTime.length; i < len; i++) {
          if (!this.canIntvTime.includes(selectedTime[i])) {
            this.canIntvTime.push(selectedTime[i])
          }
        }
      } else {
        this.canIntvTime = utils._removeArr(this.canIntvTime, selectedTime);
      }
    },
    hideScrollBar() {
      let el = $(".intvTimeCale .scroll_content");
      let scrollWidth = el[0].offsetWidth - el[0].clientWidth;
      el.css("marginRight", "-" + scrollWidth + "px")
    },
    registerScroll() {
      let el = $(".intvTimeCale .scroll_content");
      let scrollContentHeight = el.height();
      let scrollHeight = el[0].scrollHeight;
      let maxScrollNum = scrollHeight - (scrollContentHeight + 4 * 32) - 2 + 10;
      let minScrollNum = 32 * 16;
      if(this.customDataObj && this.customDataObj.isShowWeekTip){
        maxScrollNum = maxScrollNum + 24
      }
      //注册滚动监听
      el.unbind("scroll");
      el.scroll(function () {
        if (el.scrollTop() < minScrollNum) {
          el.scrollTop(minScrollNum)
        } else if (el.scrollTop() > maxScrollNum) {
          el.scrollTop(maxScrollNum)
        }
      })
    },
    formtCanintvTimeArr(ableInterviewTime) {
      //绘制可面试时间结构数组
      for (let x in ableInterviewTime) {
        let dayTimeArr = ableInterviewTime[x].periodList;
        for (let y in dayTimeArr) {
          let startH = new Date(dayTimeArr[y].startTime).getHours();
          let endH = new Date(dayTimeArr[y].endTime).getHours();
          let startMin = new Date(dayTimeArr[y].startTime).getMinutes();
          let endMin = new Date(dayTimeArr[y].endTime).getMinutes();
          if (endH == 0 && endMin == 0) {
            endH = 24;
          }
          startMin = startMin < 30 ? '00' : '30';
          if (endMin == 0) {
            endMin = '00'
          } else if (endMin <= 30 && endMin > 0) {
            endMin = '30'
          } else {
            endMin = '00';
            endH++;
          }
          let startTimeNum = new Date(utils.dateFormat('yyyy/MM/dd',ableInterviewTime[x].interviewDate) + " " + startH + ":" + startMin).getTime();
          let endTimeNum = new Date(utils.dateFormat('yyyy/MM/dd',ableInterviewTime[x].interviewDate) + " " + endH + ":" + endMin).getTime();
          do {
            if (!this.canIntvTime.includes(startTimeNum)) {
              this.canIntvTime.push(startTimeNum);
            }
            //存放备份数据
            if (!this.canIntvTimeBackups.includes(startTimeNum)) {
              this.canIntvTimeBackups.push(startTimeNum);
            }
            startTimeNum = startTimeNum + 1800000;
          } while (startTimeNum < endTimeNum)
        }
      }
    },
    formtUnableIntvTimeArr(unableInterviewTime) {
      for (let x in unableInterviewTime) {
        let dayTimeArr = unableInterviewTime[x].periodList;
        for (let y in dayTimeArr) {
          let startH = new Date(dayTimeArr[y].startTime).getHours();
          let endH = new Date(dayTimeArr[y].endTime).getHours();
          let startMin = new Date(dayTimeArr[y].startTime).getMinutes();
          let endMin = new Date(dayTimeArr[y].endTime).getMinutes();
          if (startMin < 30) {
            if (startMin !== 0) {
              startMin = '30'
            } else {
              startMin = '00'
            }
          } else {
            if (startMin !== 30) {
              startMin = '00';
              startH++;
            } else {
              startMin = '30'
            }
          }

          if (endMin == 0) {
            endMin = '00'
          } else if (endMin <= 30 && endMin > 0) {
            if (endMin == 30) {
              endMin = '30'
            } else {
              endMin = '00'
            }
          } else {
            endMin = '30';
          }
          let startTimeNum = new Date(unableInterviewTime[x].interviewDate + " " + startH + ":" + startMin).getTime();
          let endTimeNum = new Date(unableInterviewTime[x].interviewDate + " " + endH + ":" + endMin).getTime();
          if (startTimeNum < endTimeNum) {
            do {
              if (!this.unableTime.includes(startTimeNum)) {
                this.unableTime.push(startTimeNum);
              }
              startTimeNum = startTimeNum + 1800000;
            } while (startTimeNum < endTimeNum)
          }

        }
      }
    },
    mousedownBody() {
      if (this.pageState === 'edit') {
        this.ishoverState = true;
        //注册外部抬起鼠标按钮及鼠标超出时间选择窗口的行为事件
        let _this = this;
        document.addEventListener('mouseup', _this.closeHoverState);
        document.addEventListener('mousemove', _this.mousemoveBody);
      }
    },
    mousemoveBody(e) {
      if (this.pageState === 'edit' && this.ishoverState) {
        // let body_startX = $(".intvTimeCale .date_body")[0].getBoundingClientRect().x;
        let body_startY = $(".intvTimeCale .date_body")[0].getBoundingClientRect().y;
        // let body_endX = body_startX + $(".intvTimeCale .date_body").width() - 62;
        let body_endY = body_startY + $(".intvTimeCale .date_body").height();
        let _this = this;
        if (e.clientY > (body_endY + 5)) {
          this.scrollSpeed = e.clientY - body_endY;
          if (!this.scrollTimer) {
            this.scrollTimer = setInterval(() => {
              let el = $(".intvTimeCale .scroll_content");
              el.scrollTop(el.scrollTop() + _this.scrollSpeed)
            }, 100)
          }
        } else if (e.clientY < (body_startY - 5)) {
          this.scrollSpeed = e.clientY - body_startY;
          if (!this.scrollTimer) {
            this.scrollTimer = setInterval(() => {
              let el = $(".intvTimeCale .scroll_content");
              el.scrollTop(el.scrollTop() + _this.scrollSpeed)
            }, 100)
          }
        } else {
          if (this.scrollTimer) {
            clearInterval(this.scrollTimer);
            this.scrollTimer = null;
          }
        }
      }
    },
    mousedownNode(e, timeNum) {
      this.startMoveTime = this.endMoveTime = timeNum;
    },
    mouseenterNode(e, timeNum) {
      if (!this.ishoverState) {
        return;
      }
      this.endMoveTime = timeNum;
    },
    closeHoverState() {
      if (this.ishoverState) {
        //将选择转态设置为false
        this.ishoverState = false;
        //清除鼠标超出时间选择窗口时的轮询滚动定时器
        clearInterval(this.scrollTimer);
        //解绑外部抬起鼠标按钮及鼠标超出时间选择窗口的行为事件
        let _this = this;
        document.removeEventListener('mouseup', _this.closeHoverState);
        document.removeEventListener('mousemove', _this.mousemoveBody);
        //开始对框选的时间格子与已选的格子及不可用格子做比较
        let selectedTime;
        if (this.startMoveTime <= this.endMoveTime) {
          selectedTime = this.createTimeList(this.startMoveTime, this.endMoveTime);
        } else {
          selectedTime = this.createTimeList(this.endMoveTime, this.startMoveTime);
        }
        //注释下面一行，框选时间后不抛除不可面试时间
        // selectedTime = utils._removeArr(selectedTime, this.unableTime);
        selectedTime = selectedTime.concat(this.canIntvTime);
        let selectObj = {};
        for (let i = 0, len = selectedTime.length; i < len; i++) {
          if (!selectObj[selectedTime[i]]) {
            selectObj[selectedTime[i]] = 1
          } else {
            selectObj[selectedTime[i]]++;
          }
        }
        let newSelectTime = [];
        for (let key in selectObj) {
          if (selectObj[key] == 1) {
            newSelectTime.push(Number(key));
          }
        }
        this.canIntvTime = newSelectTime;
        this.judgeIsAllSelectedOneDay();//计算当前周的每一天是否全选
      }
    },

    /**
     * 获取某一时间段内半小时整点的时间
     * @param startTime 开始时间 时间戳
     * @param endTime 结束时间 时间戳
     * @returns {[]} 时间点集合
     */
    createTimeList(startTime, endTime) {
      let timeNodeList = [];
      do {
        timeNodeList.push(startTime);
        startTime = startTime + 1800000;
      } while (startTime <= endTime)
      return timeNodeList;
    },
    judgeIsHover(timeNum) {
      if (!this.ishoverState || this.startMoveTime == '' || this.endMoveTime == '') {
        return false;
      }
      if ((timeNum >= this.startMoveTime && timeNum <= this.endMoveTime) || (timeNum <= this.startMoveTime && timeNum >= this.endMoveTime)) {
        return true;
      } else {
        return false;
      }
    },
    judgeIsUnable(timeNum) {
      if (this.unableTime.includes(timeNum)) {
        return true;
      } else {
        return false;
      }
    },
    judgeIsAble(timeNum) {
      if (this.canIntvTime.includes(timeNum)) {
        return true;
      } else {
        return false;
      }
    },
    judgeIsToday(timeStr) {
      return utils.dateFormat('yyyy/MM/dd') == timeStr;
    },
    judgeIsOfCurWeek() {
      return this.weekDateList.includes(utils.dateFormat('yyyy/MM/dd'));
    },
    judgeIsShowMin(timeNum) {
      if (this.noIntPointTime[timeNum] !== undefined) {
        return true;
      } else {
        return false;
      }
    },
    judgeMinIsUnable(timeNum, index) {
      let isUnable = false;
      let timeMinNum = timeNum + index * 5 * 60 * 1000;
      isUnable = (this.noIntPointTime[timeNum] !== undefined && this.noIntPointTime[timeNum].includes(timeMinNum)) ? true : false;
      return isUnable;

    },
    judgeIsAllSelectedOneDay() {
      let limitTime = [];
      if (this.isLimit_8_22) {
        let timeNum = [0, 1, 2, 3, 4, 5, 6, 7, 22, 23];
        for (let index in this.weekDateList) {
          let dayStr = this.weekDateList[index];
          for (let i in timeNum) {
            limitTime.push(new Date(dayStr + " " + timeNum[i] + ":00:00").getTime(), new Date(dayStr + " " + timeNum[i] + ":30:00").getTime())
          }
        }
      }
      // let allHaveColorTime = Array.from(new Set(this.canIntvTime.concat(this.unableTime).concat(limitTime)));
      let allHaveColorTime = Array.from(new Set(this.canIntvTime.concat(limitTime))); //全部选中不计算不可选时间
      let dayTimeObj = {};
      for (let i = 0, len = allHaveColorTime.length; i < len; i++) {
        let dayStr = utils.dateFormat("yyyy/MM/dd", allHaveColorTime[i]);
        if (dayTimeObj[dayStr]) {
          dayTimeObj[dayStr]++
        } else {
          dayTimeObj[dayStr] = 1;
        }
      }
      for (let index in this.weekDateList) {
        if (dayTimeObj[this.weekDateList[index]] === 48 && new Date(this.getZeroTime(this.weekDateList[index])) > new Date(this.getZeroTime())) {
          this.allSelectedArr[index] = true;
        } else {
          this.allSelectedArr[index] = false;
        }
      }
    },
    calcTop(timeObj) {
      let timePer = (new Date(timeObj.startTime).getTime() - this.getZeroTime(timeObj.startTime)) / (24 * 60 * 60 * 1000);
      let caleHeight = this.pageConstant.dateBlockHeight;
      return new Number(caleHeight * timePer).toFixed() + 'px';
    },
    calcHeight(timeObj) {
      let startDate = new Date(timeObj.startTime);
      let startM = startDate.getMinutes();
      let startH = startDate.getHours();
      let initWholePoint;
      let intervalNum = 0;
      if(startM >= 30){
        initWholePoint = new Date(utils.dateFormat('yyyy/MM/dd',timeObj.startTime) + ' ' + (startH+1) + ':00:00').getTime();
      }else {
        initWholePoint = new Date(utils.dateFormat('yyyy/MM/dd',timeObj.startTime) + ' ' + startH + ':30:00').getTime();
      }
      while (new Date(timeObj.endTime).getTime() > initWholePoint){
        initWholePoint += 1800000;
        intervalNum++;
      }

      let timeMin = (new Date(timeObj.endTime).getTime() - new Date(timeObj.startTime).getTime()) / (60 * 1000);
      return (timeMin * 1 + 2*intervalNum) + 'px';
    },
    caleHeightForToday(value) {
      if (new Date(this.getZeroTime(value)) < new Date(this.getZeroTime())) {
        return (this.pageConstant.dateBlockHeight - this.pageConstant.hoursBlockMarginBtm) + 'px';
      } else {
        let timePer = (new Date().getTime() - this.getZeroTime()) / (24 * 60 * 60 * 1000);
        let caleHeight = this.pageConstant.dateBlockHeight;
        return (caleHeight * timePer) + 'px';
      }
    },
    judgeIsChangeOriginData() {
      if (this.canIntvTime.sort().join() !== this.canIntvTimeBackups.sort().join()) {
        return true;
      }
      return false;
    },

    formatCompleteTime(itemDay, itemHourseNum) {
      return new Date(itemDay + " " + this.formatScale(itemHourseNum)).getTime();
    },
    formatScale(num) {
      num = num - 1;
      let int = parseInt(num / 2);
      let remain = num % 2;
      if (int < 10) {
        int = "0" + int;
      }
      if (remain > 0) {
        return int + ":30";
      } else {
        return int + ":00";
      }
    },
    assemblyDataToForm() {
      let assemblyData = {
        "pageState": this.pageState,
        "noPromptTipFlag": this.noTipOfWeek,
        "pkId": this.customDataObj.pkId,
        "ableInterviewTime": [],
        "unableInterviewTime": [],
        "selected": false
      };
      //可面试时间格式化
      let ableTime = {};
      let timeDay = this.startSelectedDate;

      // do {
      //   ableTime[utils.dateFormat('yyyy/MM/dd', timeDay)] = [];
      //   timeDay = timeDay + 86400000;
      // } while (timeDay <= this.endSelectedDate)
      // for (let index in this.canIntvTime) {
      //   let dayStr = utils.dateFormat("yyyy/MM/dd", this.canIntvTime[index]);
      //   if (ableTime[dayStr] === undefined) {
      //     ableTime[dayStr] = [];
      //   }
      //   ableTime[dayStr].push({
      //     'startTime': utils.dateFormat("yyyy/MM/dd hh:mm:ss", this.canIntvTime[index]),
      //     'endTime': utils.dateFormat("yyyy/MM/dd hh:mm:ss", this.canIntvTime[index] + 1800000)
      //   })
      // }

      do {
        ableTime[timeDay] = [];
        timeDay = timeDay + 86400000;
      } while (timeDay <= this.endSelectedDate)
      for (let index in this.canIntvTime) {
        let dayStr = this.canIntvTime[index];
        if (ableTime[dayStr] === undefined) {
          ableTime[dayStr] = [];
        }
        ableTime[dayStr].push({
          'startTime': this.canIntvTime[index],
          'endTime': this.canIntvTime[index] + 1800000
        })
      }
      for (let key in ableTime) {
        assemblyData.ableInterviewTime.push({"interviewDate": key, "periodList": ableTime[key]})
      }
      assemblyData.selected = this.judgeIsChangeOriginData();
      return assemblyData;
    }
  }
}
</script>
<style lang="less">
.intvTimeCale {
  font-size: 12px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: stretch;

  .pointer {
    cursor: pointer;
  }

  .cale_tip {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    flex-shrink: 0;
    flex-grow: 0;
    padding: 0 16px;

    .no_select {
      color: #FF991C;
      display: flex;
      align-items: center;

      .icon_tip {
        margin-right: 3px;
      }
    }

    .color_desc {
      color: #333333;
      display: flex;
      flex-direction: row;

      .can_intv {
        display: flex;
        align-items: center;
      }

      .cannot_intv {
        display: flex;
        align-items: center;
        margin-left: 24px;
      }

      .can_colorBlock {
        width: 16px;
        height: 16px;
        background: #DCFAE4;
        border-radius: 1px;
        margin-right: 8px;
      }

      .cannot_colorBlock {
        width: 16px;
        height: 16px;
        background: #EAEAEA;
        border-radius: 1px;
        margin-right: 8px;
      }

    }
  }

  .cale {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: stretch;

    .cale_changeDate {
      height: 36px;
      display: flex;
      flex-shrink: 0;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: #FAFAFA;
      color: #212121;
      font-size: 14px;
      padding: 0 20px;
      .tab_week{
        display: flex;
        flex-shrink: 0;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

      .unable {
        color: #c1c5cc;
        cursor: not-allowed;

      }

      .date_text {

        margin: 0 21px;
      }

      .date_today {
        border-radius: 50%;
        /* border: 1px solid var(--theme-color); */
        background: #5582F3;
        background: var(--theme-color);
        margin-left: 10px;
        color: #FFFFFF;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
        transform: scale(0.833);
      }
    }

    .cale_body {
      padding: 0 16px 16px 16px;
      color: #333333;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: stretch;
      flex-grow: 1;
      flex-shrink: 1;
      height: 100px;

      .date_title {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        height: 48px;
        flex-shrink: 0;

        .blank_space {
          width: 62px;
          text-align: end;
          padding-right: 13px;
          line-height: 48px;
          color: #999999;
        }

        .date_title_items {
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          flex-shrink: 1;
          align-items: stretch;

          .title_item {
            width: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-grow: 1;
            flex-shrink: 1;
            color: #333333;

            .el-checkbox {
              .el-checkbox__inner:hover{
                border-color: #5582F3;
                border-color: var(--theme-color);
              }
              .is-checked {
                .el-checkbox__inner {
                  background: #5582F3;
                  background: var(--theme-color);
                  border-color: #5582F3;
                  border-color: var(--theme-color);
                }
              }
              .is-focus {
                .el-checkbox__inner {
                  border-color: #5582F3;
                  border-color: var(--theme-color);
                }
              }

              .el-checkbox__label {
                color: #333333 !important;
                font-size: 12px;
              }
            }

            .isToday {
              width: 18px;
              height: 18px;
              line-height: 18px;
              text-align: center;
              flex-shrink: 0;
              margin-left: 1px;
              margin-bottom: 3px;
              border-radius: 50%;
              background: #5582F3;
              background: var(--theme-color);
              color: #FFFFFF;
              transform: scale(0.833);
            }
          }

          .hideInputBox {
            .el-checkbox__input {
              display: none;
            }
          }
        }

      }

      .date_body {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        flex-grow: 1;
        flex-shrink: 1;
        height: 100px;
        overflow-x: hidden;

        .scroll_content {
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          flex-shrink: 1;
          overflow-y: scroll;
          align-items: start;
        }

        .date_body_scale {
          width: 62px;
          display: flex;
          flex-direction: column;
          justify-content: start;
          align-items: stretch;

          .scale_item {
            flex-shrink: 0;
            height: 30px;
            margin-bottom: 2px;
            text-align: end;
            padding-right: 13px;
          }
        }

        .date_body_content {
          position: relative;
          display: flex;
          flex-direction: row;
          flex-grow: 1;
          flex-shrink: 1;


          .day_list {
            width: 100px;
            position: relative;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            flex-shrink: 1;

            .hours_list {
              display: flex;
              flex-direction: row;
              align-items: stretch;
              flex-shrink: 0;
              height: 30px;
              margin: 0 2px 2px 0;
              background: #F8F8F8;

              .min_list {
                display: flex;
                flex-grow: 1;
                flex-direction: column;
                align-items: stretch;

                .min_list_item {
                  flex-grow: 1;
                  flex-shrink: 1;
                  height: 10px;
                }
              }
            }

            .viewTime_block {
              position: absolute;
              width: calc(100% - 2px);
              top: 0;
              left: 0;

              .viewBlock_item {
                position: absolute;
                width: 100%;
                left: 0;
                background: #DCFAE4;
                padding-top: 4px;
                text-align: center;
                color: #1BA854;
              }
            }

            .viewunableTime_block {
              position: absolute;
              width: calc(100% - 2px);
              top: 0;
              left: 0;

              .viewunableBlock_item {
                //opacity: 0.5;
                position: absolute;
                width: 100%;
                left: 0;
                background: #EAEAEA;
                padding-top: 4px;
                text-align: center;
              }
            }

            .ishover {
              background: #DCFAE4;
            }

            .isunable {
              //background: #EAEAEA !important; //暂不需要颜色区分，先留存
            }

            .isable {
              background: #DCFAE4;
            }
          }

          .timeLine {
            width: calc(100% - 2px);
            height: 2px;
            background: #FF736C;
            position: absolute;
            display: flex;
            justify-content: start;
            align-items: center;
            left: 0;
            top: 0;

            .dot {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #FF736C;
              margin-left: -6px;
            }
          }
          .occupy{
            position: absolute;
            width: 100%;
            top: 1406px;
            height: 32px;
            background: #FFFFFF;
          }
        }
      }
    }
  }

  .noTipOfWeek {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    margin-top: -16px;

    .el-checkbox__label {
      color: #333333 !important;
      font-size: 12px;
    }
  }
}
</style>